import { render, staticRenderFns } from "./Belge.vue?vue&type=template&id=529867dc&"
import script from "./Belge.vue?vue&type=script&lang=js&"
export * from "./Belge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports